<script>
    import notificacaoServico from '~modulos/notificacoes/servico';
    import tipoUsuario from '~js/tipo-usuario';
    import acessos from '~js/acessos';
    import CardNotificacao from './CardNotificacao.vue';
    import CardAviso from './CardAviso.vue';

    import 'select2';
    import 'select2/dist/js/i18n/pt-BR';

    const ORDEM_TIPOS_SOLICITACAO_LIBERACAO = [5, 2, 1, 18, 3, 6, 7, 8, 4, 9, 13, 14, 10, 15, 16];

    const CONSULTAS_PENDENCIAS = {
      diarias: { metodo: 'listaPendenciasDiarias', campo: 'diarias', descricao: 'as diárias' },
      pagamentos: { metodo: 'listaPendenciasPagamentos', campo: 'pagamentosPendentes', descricao: 'os pagamentos' },
      provisoes: { metodo: 'listaPendenciasProvisoes', campo: 'provisoes', descricao: 'as provisões' },
    };

    export default {
      components: { CardNotificacao, CardAviso },
      data() {
        return {
          usuario: this.$storage.usuario(),
          tipoUsuario: tipoUsuario,
          configuracao: this.$storage.configuracao(),
          notificacoes: [],
          solicitacoes: [],
          mensagens: [],
          pedidos: [],
          pesquisasPrecoAprovacao: [],
          pesquisasPassagemAprovacao: [],
          projetosTerminando: [],
          pendencias: [],
          quantidadePedidos: 0,
          quantidadePesquisasNaoAprovadas: 0,
          quantidadeProjetosTerminando: 0,
          mostrarSolicitacoes: false,

          carregandoSolicitacao: false,
          carregandoMensagem: false,
          carregandoPedidos: false,
          carregandoPesquisasPrecoAprovacao: false,
          carregandoPesquisasPassagemAprovacao: false,
          carregandoProjetosTerminando: false,
          consultasPendenciasAbertas: 0,
          resumoPendencias: {},
          falhasPendencias: [],

          filtroMensagem:{
            modulo: '0',
            idProjeto: '0',
            mostrarMensagens: '1',
            numero: '',
          },
          carregando: false,
        }
      },
      methods: {
        retornaDescricao(modulo){
          switch (modulo) {
            // Compras;
            case 1:
              return "Solicitação de Compra";
            // Solicitação de bolsas, RPA ou estágio
            case 2:
              return 'Solicitação de ' + this.configuracao.nomeModuloSolContratos;
            //Curso, evento ou serviço
            case 3:
              return 'Solicitação de ' + this.configuracao.nomeModuloSolCursoEventoServico;
            //Solicitação de Pagamento Pessoa Física
            case 4:
              return "Solicitação de Pagamento Pessoa Física";
            //Solicitação de Adiantamento
            case 5:
              return "Solicitação de Adiantamento";
            //Solicitação de Passagens, Diárias e Adiantamento
            case 6:
              let passagem = this.configuracao.utilizarSolicitacaoAdiantamentoPassagemWeb ? ' - Passagem' : '';
              let adiantamento = this.configuracao.utilizarSolicitacaoAdiantamentoWeb ? ' - Adiantamento' : '';

              return 'Solicitação de Diária ' + passagem + adiantamento;
            //Solicitação Faturamento
            case 7:
              return "Solicitação de Faturamento";
            //Solicitação Faturamento Multiserviços
            case 8:
              return "Solicitação de Importação";
            //Solicitação Pagamento Pessoa Jurídica
            case 9:
              return "Solicitação de Pagamento Pessoa Jurídica";
            //Solicitação Reembolso Terceiro
            case 10:
              return "Solicitação de Reembolso Terceiro";
            //Solicitação de Pagamento Estrangeiro PF
            case 13:
              return "Solicitação de Pagamento Estrangeiro PF";
            //Solicitação de Pagamento Estrangeiro PJ
            case 14:
              return "Solicitação de Pagamento Estrangeiro PJ";
            //Solicitação de Transferência
            case 15:
              return "Solicitação de Transferência";
            //Solicitação de Cancelamento Contrato
            case 16:
              return "Solicitação de Cancelamento Contrato";
            //Solicitação de Contratação Pessoal
            case 18:
              return "Solicitação de Contratação Pessoal";
          }

          return;
        },
        retornaClass(modulo) {
          switch (modulo) {
            // Compras;
            case 1:
              return "fa fa-shopping-basket compras";
            // Solicitação de bolsas, RPA ou estágio
            case 2:
              return "fa fa-address-card bolsarpaestagio";
            //Curso, evento ou serviço
            case 3:
              return "fa fa-graduation-cap cursoeventoservico";
            //Solicitação de Pagamento Pessoa Física
            case 4:
              return "fa fa-money solpf";
            //Solicitação de Adiantamento
            case 5:
              return "fa fa-money adiantamento";
            //Solicitação de Passagens, Diárias e Adiantamento
            case 6:
              return "fa fa-plane reembolso";
            //Solicitação Faturamento
            case 7:
              return "fa fa-calculator faturamento";
            //Solicitação De Importação
            case 8:
              return "fa fa-ship solImportacao";
            //Solicitação Pagamento Pessoa Jurídica
            case 9:
              return "fa fa-money solpj";
            //Solicitação Reembolso Terceiro
            case 10:
              return "fa fa-money reembolsoterceiro";
            // Pedidos para liberação;
            case 11:
              return "fa fa-shopping-cart pedidos";
            // Pesquisas de compra aprovação;
            case 12:
              return "fa fa-list-alt pesquisas";
            case 13:
              return "fa fa-money solpf";
            case 14:
              return "fa fa-money solpj";
            case 15:
              return "fa fa-refresh soltransferencia";
            case 16:
              return "fa fa-address-card-o solcancelamentocontrato";
            // Projetos Terminando
            case 17:
              return "fa fa-list-alt pesquisas";
            case 18:
              return "fa fa-users contratacaopessoal";
          }

          return;
        },
        listaNotificacoes() {
          if (!this.mensagemSistema)
            return;

          this.carregandoMensagem = true;

          return notificacaoServico.
            listaNotificacoes()
            .then(res => {
              this.carregandoMensagem = false;
              this.notificacoes = res;

              for (var i = 0; i < this.notificacoes.length; i++) {
                let notificacao = this.notificacoes[i];

                switch (notificacao.tipoNotificacao) {
                  case 1:
                    let auxNotificacao = {
                      descricao: this.retornaDescricao(notificacao.modulo),
                      quantidade: notificacao.quantidade,
                      modulo: notificacao.modulo,
                    }

                    this.mensagens.push(auxNotificacao);
                    break;
                  case 2:
                    break;
                }
              }

            });
        },
        listaPedidosNaoLiberados() {
          if (!this.pedidosCompra)
            return;

          this.carregandoPedidos = true;

          return notificacaoServico.
            listaPedidosNaoLiberados()
            .then(res => {
              this.carregandoPedidos = false;
              this.quantidadePedidos = res;

              if (parseInt(this.quantidadePedidos) > 0) {
                let auxNotificacao = {
                  descricao: "Pedidos de compras pendente de liberação",
                  quantidade: this.quantidadePedidos,
                  modulo: 11,
                  rota: { name: 'liberar-pedidos-compra' },
                }

                this.pedidos.push(auxNotificacao);
              }
            });
        },
        listaPesquisasNaoAprovadas() {
          if (!this.aprovacaoPesquisaPreco)
            return;

          this.carregandoPesquisasPrecoAprovacao = true;

          return notificacaoServico.
            listaPesquisasNaoAprovadas()
            .then(res => {
              this.carregandoPesquisasPrecoAprovacao = false;
              this.quantidadePesquisasNaoAprovadas = res;

              if (parseInt(this.quantidadePesquisasNaoAprovadas) > 0) {
                let auxNotificacao = {
                  descricao: "Pesquisas de preço pendente de aprovação",
                  quantidade: this.quantidadePesquisasNaoAprovadas,
                  modulo: 12,
                  rota: { name: 'aprovar-pesquisa-preco' },
                }

                this.pesquisasPrecoAprovacao.push(auxNotificacao);
              }
            });
        },
        listaPesquisasPassagemNaoAprovadas() {
          if (!this.aprovacaoPesquisaPreco)
            return;

          this.carregandoPesquisasPassagemAprovacao = true;

          return notificacaoServico.
            listaPesquisasPassagemNaoAprovadas()
            .then(res => {
              this.carregandoPesquisasPassagemAprovacao = false;
              this.quantidadePesquisasNaoAprovadas = res;

              if (parseInt(this.quantidadePesquisasNaoAprovadas) > 0) {
                let auxNotificacao = {
                  descricao: "Pesquisas de passagem pendente de aprovação",
                  quantidade: this.quantidadePesquisasNaoAprovadas,
                  modulo: 6,
                  rota: { name: 'aprovar-passagem' },
                }

                this.pesquisasPassagemAprovacao.push(auxNotificacao);
              }
            });
        },
        listaPendencias() {
          if (!(this.solReembolsoAtividade || this.liberarPagamento || this.liberarProvisoesPagamento))
            return;

          const chaves = [];

          if (this.solReembolsoAtividade)
            chaves.push('diarias');

          if (this.liberarPagamento)
            chaves.push('pagamentos');

          if (this.liberarProvisoesPagamento)
            chaves.push('provisoes');

          return Promise.all(chaves.map(chave => this.carregarPendencia(chave)));
        },
        carregarPendencia(chave) {
          const consulta = CONSULTAS_PENDENCIAS[chave];

          this.consultasPendenciasAbertas++;
          this.falhasPendencias = this.falhasPendencias.filter(falha => falha !== chave);
          this.pendencias = this.montarPendencias(this.resumoPendencias);

          return notificacaoServico[consulta.metodo]()
            .then(res => {
              this.resumoPendencias = Object.assign({}, this.resumoPendencias, {
                [consulta.campo]: res ? res[consulta.campo] : null,
              });
            })
            .catch(() => {
              this.falhasPendencias = this.falhasPendencias.concat(chave);
            })
            .then(() => {
              this.consultasPendenciasAbertas--;
              this.pendencias = this.montarPendencias(this.resumoPendencias);
            });
        },
        montarPendencias(res) {
          const itens = [];
          const adicionar = (quantidade, item) => {
            if (quantidade > 0) {
              itens.push(Object.assign({ quantidade }, item));
            }
          };

          if (this.liberarPagamento && res.pagamentosPendentes != null) {
            adicionar(res.pagamentosPendentes, {
              descricao: 'Pagamentos pendentes de liberação',
              icone: 'fa fa-check-square-o',
              cor: '#0e9f8e',
              rota: { name: 'liberar-pagamento', query: { situacao: '1' } },
            });
          }

          if (this.liberarProvisoesPagamento && res.provisoes) {
            adicionar(res.provisoes.aguardando, {
              descricao: 'Provisões aguardando liberação',
              icone: 'fa fa-money',
              cor: '#d9820b',
              rota: { name: 'liberar-provisoes-pagamento', query: { mostrar: '7' } },
            });
            adicionar(res.provisoes.entrarEmContato, {
              descricao: 'Provisões em atraso – contatar a Fundação',
              icone: 'fa fa-money',
              cor: '#d9820b',
              rota: { name: 'liberar-provisoes-pagamento', query: { mostrar: '8' } },
            });
          }

          if (this.solReembolsoAtividade && res.diarias) {
            adicionar(res.diarias.pendentes, {
              descricao: 'Prestação de contas pendente (diárias, passagens e adiantamentos)',
              icone: 'fa fa-plane',
              cor: '#712cff',
              rota: { name: 'solicitacao-reembolso-pf-atividade', query: { mostrar: 'pendentes' } },
            });
          }

          this.falhasPendencias.forEach(chave => {
            itens.push({
              descricao: 'Não foi possível carregar ' + CONSULTAS_PENDENCIAS[chave].descricao,
              icone: 'fa fa-exclamation-triangle',
              cor: '#ed5565',
              erro: true,
              aoClicar: () => this.carregarPendencia(chave),
            });
          });

          return itens;
        },
        listaProjetosTerminando() {
          this.carregandoProjetosTerminando = true;

          return notificacaoServico.
            listaProjetosTerminando()
            .then(res => {
              this.carregandoProjetosTerminando = false;
              this.quantidadeProjetosTerminando = res;

              if (parseInt(this.quantidadeProjetosTerminando) > 0) {
                let auxNotificacao = {
                  descricao: "Projetos terminando",
                  quantidade: this.quantidadeProjetosTerminando,
                  modulo: 17,
                }

                this.projetosTerminando.push(auxNotificacao);
              }
            });
        },
        listaNotificacoesSolicitacoes() {
          if (!this.liberarSolicitacoes)
            return;

          this.carregandoSolicitacao = true;

          return notificacaoServico.
            contagemSolicitacoesLiberacao()
            .then(res => {
              this.carregandoSolicitacao = false;

              const contagens = {};

              (res || []).forEach(contagem => {
                contagens[contagem.tipoSolicitacao] = +contagem.quantidade;
              });

              ORDEM_TIPOS_SOLICITACAO_LIBERACAO.forEach(tipo => {
                const quantidade = contagens[tipo] || 0;

                if (quantidade <= 0)
                  return;

                if (tipo === 13 && !this.configuracao.solPgtoPFEstrangeiro)
                  return;

                if (tipo === 14 && !this.configuracao.solPgtoPJEstrangeiro)
                  return;

                this.mostrarSolicitacoes = true;

                this.solicitacoes.push({
                  descricao: this.retornaDescricao(tipo),
                  quantidade: quantidade,
                  modulo: tipo,
                });
              });
            });
        },
      },
      mounted() {
        this.$root.tituloDaPagina = `Notificações`;
        this.$root.botaoAcaoMostrar = false;

        this.$root.botaoRetrocederMostrar = false;
        this.$root.botaoRetrocederRota = '';
      },
      computed: {
        coordenador() {
          return this.usuario.tipoUsuario === tipoUsuario.Coordenador;
        },
        aluno() {
          return this.usuario.tipoUsuario === tipoUsuario.Aluno;
        },
        fornecedor() {
          return this.usuario.tipoUsuario === tipoUsuario.Fornecedor;
        },
        solCompras() {
          return this.usuario.tipoUsuario === tipoUsuario.Coordenador && this.configuracao.solCompras && this.usuario.permissoes.solCompras;
        },
        solBolsa() {
          return this.usuario.tipoUsuario === tipoUsuario.Coordenador && this.configuracao.solBolsa && this.usuario.permissoes.solBolsa;
        },
        solCursoEventoServico() {
          return this.usuario.tipoUsuario === tipoUsuario.Coordenador && this.usuario.permissoes.solCursoEventoServico;
        },
        liberarSolicitacoes() {
          return this.usuario.tipoUsuario === tipoUsuario.Coordenador && (this.usuario.permissoes.liberarSolWEB1 ||
                                                                          this.usuario.permissoes.liberarSolWEB2);
        },
        mensagemSistema() {
          return this.usuario.tipoUsuario === tipoUsuario.Coordenador && (
            (this.solBolsa) ||
            (this.solCompras) ||
            (this.solCursoEventoServico) ||
            (this.solTransferencia) ||
            (this.solPagamentoPessoaFisica) ||
            (this.solPagamentoPessoaJuridica) ||
            (this.solReembolso) ||
            (this.solFaturamento) ||
            (this.solReembolsoTerceiro) ||
            (this.solContratacaoPessoal) ||
            (this.solAdiantamento)
          ) && !this.configuracao.naoUtilizarMensageria;
        },
        pedidosCompra() {
          return this.usuario.tipoUsuario === tipoUsuario.Coordenador &&
                          this.usuario.permissoes.liberarPedidoCompra &&
                          this.configuracao.utilizarLiberacaoPedidoCoordenador;
        },
        aprovacaoPesquisaPreco() {
          return this.usuario.tipoUsuario === tipoUsuario.Coordenador &&
            this.usuario.permissoes.aprovarPesquisaPreco &&
            this.configuracao.utilizarAprovacaoPesquisaPreco;
        },
        mostraProjetosTerminando() {
          return this.usuario.tipoUsuario === tipoUsuario.Coordenador && this.quantidadeProjetosTerminando > 0;
        },
        solReembolsoAtividade() {
          return acessos.solReembolsoAtividade(this);
        },
        liberarPagamento() {
          return acessos.liberarPagamento(this);
        },
        liberarProvisoesPagamento() {
          return acessos.liberarProvisoesPagamento(this);
        },
        mostrarPendencias() {
          return this.pedidosCompra || this.aprovacaoPesquisaPreco ||
            this.solReembolsoAtividade || this.liberarPagamento || this.liberarProvisoesPagamento;
        },
        itensPendencias() {
          return [].concat(this.pedidos, this.pesquisasPrecoAprovacao, this.pesquisasPassagemAprovacao, this.pendencias);
        },
        carregandoItensPendencias() {
          const carregando = this.carregandoPedidos || this.carregandoPesquisasPrecoAprovacao ||
            this.carregandoPesquisasPassagemAprovacao || this.consultasPendenciasAbertas > 0;

          return carregando && this.itensPendencias.length === 0;
        },
      },
      created() {
        this.listaNotificacoes();
        this.listaNotificacoesSolicitacoes();
        this.listaPedidosNaoLiberados();
        this.listaPesquisasNaoAprovadas();
        this.listaPesquisasPassagemNaoAprovadas();
        this.listaProjetosTerminando();
        this.listaPendencias();
      },
    }
</script>

<template>
    <div :class="['wrapper wrapper-content animated', $root.animacaoPadrao]">
        <div class="row" v-if="configuracao.mensagemAvisoGeral">
            <div class="col-lg-12">
                <div class="ibox float-e-margins">
                    <card-aviso :titleCard="'Aviso'"
                                :texto="configuracao.mensagemAvisoGeral">
                    </card-aviso>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4">
                <card-notificacao v-if="liberarSolicitacoes"
                                  :itens="solicitacoes"
                                  :carregando="carregandoSolicitacao"
                                  :titleCard="'Solicitações pendentes de liberação'"
                                  :rotaBotao="{ name: 'liberar-solicitacoes' }"
                                  :textoBotao="'Acessar liberação'"
                                  :semItemTexto="'Sem solicitações pendentes de liberação'">
                </card-notificacao>

                <card-notificacao v-if="mostraProjetosTerminando"
                                  :itens="projetosTerminando"
                                  :carregando="carregandoProjetosTerminando"
                                  :titleCard="'Projetos terminando'"
                                  :rotaBotao="{ name: 'termino-projetos' }"
                                  :textoBotao="'Acessar projetos terminando'"
                                  :semItemTexto="'Sem projetos terminando'">
                </card-notificacao>
            </div>

            <div class="col-lg-4">
                <card-notificacao v-if="mensagemSistema"
                                  :itens="mensagens"
                                  :carregando="carregandoMensagem"
                                  :titleCard="'Mensagens pendentes de leitura'"
                                  :rotaBotao="{ name: 'mensagem', params: { filtrosBag : filtroMensagem } }"
                                  :textoBotao="'Acessar mensagens'"
                                  :semItemTexto="'Sem mensagens pendentes de leitura'">
                </card-notificacao>

                <card-notificacao v-if="mostrarPendencias"
                                  :itens="itensPendencias"
                                  :carregando="carregandoItensPendencias"
                                  :titleCard="'Pendências para resolver'"
                                  :semItemTexto="'Sem pendências de liberação, aprovação ou prestação de contas'">
                </card-notificacao>
            </div>

            <div class="col-lg-4">
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/notificacoes/componentes/Notificacao.vue